var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabflecha120X8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 9,
    viewBox: "0 0 122 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H47.7889C48.5786 1 49.3506 1.23375 50.0077 1.6718L58.7812 7.5208C60.1248 8.41653 61.8752 8.41653 63.2188 7.5208L71.9923 1.6718C72.6494 1.23375 73.4214 1 74.2111 1H121",
    stroke: "#3677DE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabflecha120X8);
export default __webpack_public_path__ + "static/media/TABFLECHA_120X8.4ac4b081298291275371a19d005b813f.svg";
export { ForwardRef as ReactComponent };